var allStates = {
    "AL": "Alabama",
    "AK": "Alaska",
    "AS": "American Samoa",
    "AZ": "Arizona",
    "AR": "Arkansas",
    "CA": "California",
    "CO": "Colorado",
    "CT": "Connecticut",
    "DE": "Delaware",
    "DC": "District Of Columbia",
    "FM": "Federated States Of Micronesia",
    "FL": "Florida",
    "GA": "Georgia",
    "GU": "Guam",
    "HI": "Hawaii",
    "ID": "Idaho",
    "IL": "Illinois",
    "IN": "Indiana",
    "IA": "Iowa",
    "KS": "Kansas",
    "KY": "Kentucky",
    "LA": "Louisiana",
    "ME": "Maine",
    "MH": "Marshall Islands",
    "MD": "Maryland",
    "MA": "Massachusetts",
    "MI": "Michigan",
    "MN": "Minnesota",
    "MS": "Mississippi",
    "MO": "Missouri",
    "MT": "Montana",
    "NE": "Nebraska",
    "NV": "Nevada",
    "NH": "New Hampshire",
    "NJ": "New Jersey",
    "NM": "New Mexico",
    "NY": "New York",
    "NC": "North Carolina",
    "ND": "North Dakota",
    "MP": "Northern Mariana Islands",
    "OH": "Ohio",
    "OK": "Oklahoma",
    "OR": "Oregon",
    "PW": "Palau",
    "PA": "Pennsylvania",
    "PR": "Puerto Rico",
    "RI": "Rhode Island",
    "SC": "South Carolina",
    "SD": "South Dakota",
    "TN": "Tennessee",
    "TX": "Texas",
    "UT": "Utah",
    "VT": "Vermont",
    "VI": "Virgin Islands",
    "VA": "Virginia",
    "WA": "Washington",
    "WV": "West Virginia",
    "WI": "Wisconsin",
    "WY": "Wyoming"
};


$(function(){
    $('.order-sidebar').on('click', function(){
        $('.order-sidebar-pullout').toggle();
        $('.order-sidebar-pullout2').toggleClass('display-flex');
    });

    $('[name="change-ra"]').on('click', function() {
        if ($(this).val() == 'yes'){
            $('.hire-us').show();
            $('.hire-us').find('input').attr('required', 'required');
        }
        else {
            $('.hire-us').hide();
            $('.hire-us').find('input').removeAttr('required');

        }
    });

    // $('.inline-order-sidebar').on('click', function(){
    //     $('.order-sidebar-pullout').toggle();
    //     $('.order-sidebar-pullout2').toggleClass('display-flex');
    // });

    $('.edit-order').hide();

    $('.order-sidebar-pullout2 .button').on('click', function(){
        $('.order-sidebar-pullout2').removeClass('display-flex').hide();
    });

    $('.search-menu-item, main, .nav-container, footer, .search-g').on('click', function(e){
        if ( !$(e.target).hasClass('search-menu-item') && !$(e.target).hasClass('search-top') && !$(e.target).hasClass('mobile-search') && !$(e.target).hasClass('fa-search')) {
            $('.search-overlay').fadeOut(250);
        }
    });


    $('.home-select-state').on('click', function(){
       // $('.home-select-top i').toggleClass('rotate');
        $('.select-a-state-overlay').fadeIn(250);
        $('body').addClass('stop-scrolling2');
    });

    $('.select-a-state-overlay').on('click', function(){
         //$('.select-a-state-overlay').fadeOut(250);
         //$('body').removeClass('stop-scrolling2');
    });


    $('.exit-overlay').on('click', function(){
         $('.select-a-state-overlay').fadeOut(250);
         $('body').removeClass('stop-scrolling2');

    });

    $('.search-menu-item, .mobile-search').on('click', function(){
        $('.search-overlay').fadeToggle(250);
        //$(this).toggleClass('selected');
        $('.search-input').focus();
        //$('body').addClass('stop-scrolling2');
    });

    $('.exit-search').on('click', function(){
        $('.search-overlay').fadeOut(125);
        //$('.search-menu-item, .mobile-search').removeClass('selected');
        //$('body').removeClass('stop-scrolling2');
    });


    $('.mobile-menu').on('click', function(){
        $(this).addClass('hide-me');
        $('nav').slideDown();
        $('nav').addClass('scrollable');
        $('body').addClass('stop-scrolling');
        $(".mobile-menu-exit").removeClass('hide-me');
    });

    $('.mobile-menu-exit').on('click', function(){
        $(this).addClass('hide-me');
        $('nav').slideUp();
        $('nav').removeClass('scrollable');
        $('body').removeClass('stop-scrolling');
        $(".mobile-menu").removeClass('hide-me');
    });

    if ($('nav').hasClass('state-page')){
        $('.nav-wrapper').removeClass('padding-bottom-nav');
    }

    else{
        $('.nav-wrapper').addClass('padding-bottom-nav');
    }

    $('input[name="more-entities"]').on('change', function(){
        if ($(this).prop('checked')) {
            $(this).parent().hide();
            $('.more-entity-container').fadeIn(250);
        }
    });


    $(".select-a-state").on('change', function(){
        $('.select-state-form').submit();
        //console.log('asa');
    });


    $('.dd-menu').on('mouseenter', function(){
        //console.log('hllllo');
        $('.dd-menu-trigger').css({
            'background' : '#304071'
        });
    });



    $('.dd-menu').on('mouseleave', function(){
        //console.log('hllllo');
        $('.dd-menu-trigger').css({
            'background' : '#4860ab'
        });
    });


    $('.dd-menu-trigger').on('mouseenter', function() {
        $(this).css({
            'background' : '#304071'
        });
    });

    $('.dd-menu-trigger').on('mouseleave', function() {
        $(this).css({
            'background' : '#4860ab'
        });

    });

    $('#contact-form [type="submit"]').on('click', function(event){
        //$('.password-strength').addClass('password-check');
        $('#contact-form').find('input, textarea, select').each(function(){
            $('#contact-form').foundation('validateInput', $(this));
        });

        //console.log('sup gg');

        if( $('.is-invalid-input').length > 0 ){
            $('.is-invalid-input').first().focus();
        } else {
            event.preventDefault();
            //console.log('sup g');
            $('#contact-form').addClass('zoomOut2s');
            setTimeout(function(){
                $('#contact-form').submit();
            }, 200);

        }
    });

    var progress = 2;
    $('.form-sect').hide();
    $('.form-sect').first().show().addClass('cur');
    $('.progress-bar-text').children().first().addClass('cur-text');
    $('.control-buttons .prev').hide();
    $('.control-buttons .next').addClass('no-prev');

    $('.next').on('click', function(){
        $('.edit-order').show();

        $('#abide-form .cur').find('input, textarea, select').each(function(){
            $('#abide-form').foundation('validateInput', $(this));
        });

        if( $('#abide-form .cur .is-invalid-input').length > 0 ){
            $('.is-invalid-input').first().focus();
        } else {

            $('.control-buttons .prev').show();
            $('.control-buttons .next').removeClass('no-prev');

            //console.log(progress);
            if (progress >= 4){
                $('.control-buttons .next').hide();
                $('.control-buttons .prev').addClass('no-next');
                $('.order-sidebar').hide();
                // var str = $('#cardNumber').val();
                // str = str.replace(/\s+/g, '');
                // $('#cardNumber').val(str);
            }

            if ($('.footer-progress-bar div').hasClass('footer-progress')) {
                $('.footer-progress').removeClass('footer-progress').next().addClass('footer-progress');
            }
            $('.form-sect').removeClass('fadeInRight');
            //$('.form-sect').hide();
            //$('.cur').addClass('fadeOutRight');
            $('.cur').hide();
            //$('.cur').hide();
            $('.form-sect').hide();
            $('.cur').removeClass('cur').next().show().addClass('cur');


            $('.cur-text').removeClass('cur-text').next().addClass('cur-text');
            $('.progress').addClass('progress-step' + progress);
            progress += 1;
            //$('.cur-text').prev().addClass('cursor-p');
        }
    });

    $('.prev').on('click', function(){

        $('.order-sidebar').show();
        //$('.control-buttons .prev').show();
        $('.control-buttons .prev').removeClass('no-next');
        $('.control-buttons .next').show();

         if ($('.footer-progress-bar div').hasClass('footer-progress')) {
                $('.footer-progress').removeClass('footer-progress').prev().addClass('footer-progress');
        }

        $('.form-sect').removeClass('fadeOutRight');
        //$('.form-sect').hide();
        //$('.cur').removeClass('cur').prev().addClass('fadeInRight').addClass('cur');
        $('.cur').removeClass('cur').prev().show().addClass('cur');
        $('.form-sect').hide();
        $('.cur').show();


        $('.cur-text').removeClass('cur-text').prev().addClass('cur-text');
        progress = progress - 1;
        $('.progress').removeClass('progress-step' + progress);


        if (progress <= 2){
            $('.control-buttons .prev').hide();
            $('.control-buttons .next').addClass('no-prev');
            $('.edit-order').hide();
        }

    });

    $('.progress-bar-text .step1, .edit-order').on('click', function(){
        $('.edit-order').hide();
        var cur_step = progress - 1;
        var clicked_step = -1;
        if (cur_step > 1) {
            $('.order-sidebar').show();
            $('.form-sect').hide().removeClass('cur');
            $('.form-sect').first().show().addClass('cur');
            $('.progress').removeClass('progress-step1').removeClass('progress-step2').removeClass('progress-step3').removeClass('progress-step4');
            $('.progress').addClass('progress-step1');
            $('.progress-bar-text li').removeClass('cur-text');
            $('.progress-bar-text li').first().addClass('cur-text');
            $('.footer-progress-bar div').removeClass('footer-progress');
            $('.footer-progress-bar div').first().addClass('footer-progress');
            progress = 2;
            // console.log(progress);

            //$('.progress-bar-text li').removeClass('cursor-p');
            //$('.cur-text').addClass('cursor-p');

            $('.control-buttons .prev').hide().removeClass('no-next');
            $('.control-buttons .next').show().addClass('no-prev');
        }
    });

    $('.progress-bar-text .step2').on('click', function(){
        var cur_step = progress - 1;
        var clicked_step = -1;
        if (cur_step > 2) {
            $('.order-sidebar').show();
            $('.form-sect').hide().removeClass('cur');
            $('.form-sect').first().next().show().addClass('cur');
            $('.progress').removeClass('progress-step1').removeClass('progress-step2').removeClass('progress-step3').removeClass('progress-step4');
            $('.progress').addClass('progress-step2');
            $('.progress-bar-text li').removeClass('cur-text');
            $('.progress-bar-text li').first().next().addClass('cur-text');
            $('.footer-progress-bar div').removeClass('footer-progress');
            $('.footer-progress-bar div').first().next().addClass('footer-progress');
            progress = 3;
            //console.log(progress);


            $('.control-buttons .next, .control-buttons .prev').removeClass('no-prev').removeClass('no-next');
            $('.control-buttons .next').show();
        }
    });

    $('.progress-bar-text .step3').on('click', function(){
        var cur_step = progress - 1;
        var clicked_step = -1;
        if (cur_step > 3) {
            $('.order-sidebar').show();
            $('.form-sect').hide().removeClass('cur');
            $('.form-sect').first().next().next().show().addClass('cur');
            $('.progress').removeClass('progress-step1').removeClass('progress-step2').removeClass('progress-step3').removeClass('progress-step4');
            $('.progress').addClass('progress-step3');
            $('.progress-bar-text li').removeClass('cur-text');
            $('.progress-bar-text li').first().next().next().addClass('cur-text');
            $('.footer-progress-bar div').removeClass('footer-progress');
            $('.footer-progress-bar div').first().next().next().addClass('footer-progress');
            progress = 4;
            //console.log(progress);

            $('.control-buttons .next, .control-buttons .prev').removeClass('no-prev').removeClass('no-next');
            $('.control-buttons .next').show();
        }
    });


    $('.sticky-reveal-button').on('click', function(){
        $('.hideable-fact').slideToggle();
        $(this).toggleClass('flipped');
    });

    if ($('.nav-bottom i').hasClass('flipped')) {
        $('.hideable-fact').slideUp();
    }


});






$(window).load(function(){
        $('#select-state-m').select2();
        var s2 = $('#select-state-m');
        $('#select-all-states').on('click', function(){

            if ($('#select-all-states:checked').length > 0){

                s2.val( ["AL",
                "AK",
                "AS",
                "AZ",
                "AR",
                "CA",
                "CO",
                "CT",
                "DE",
                "DC",
                "FM",
                "FL",
                "GA",
                "GU",
                "HI",
                "ID",
                "IL",
                "IN",
                "IA",
                "KS",
                "KY",
                "LA",
                "ME",
                "MH",
                "MD",
                "MA",
                "MI",
                "MN",
                "MS",
                "MO",
                "MT",
                "NE",
                "NV",
                "NH",
                "NJ",
                "NM",
                "NY",
                "NC",
                "ND",
                "MP",
                "OH",
                "OK",
                "OR",
                "PW",
                "PA",
                "PR",
                "RI",
                "SC",
                "SD",
                "TN",
                "TX",
                "UT",
                "VT",
                "VI",
                "VA",
                "WA",
                "WV",
                "WI",
                "WY"]).trigger('change');
            }

            else{
                s2.val(['']).trigger('change');
            }
        });

        $('#select-state-m').on('change', function(){

            if (s2.val() !== null && s2.val().length < 51) {
                $('#select-all-states').prop('checked', false);
            }
        });

        $('.select-a-state-overlay').css({
            "opacity" : 1,
            "z-index" : 300
        });
        $('.select-a-state-overlay').hide();




    $('.pos-sticky-bottom').show();

    //issues currently with very large windows like imacs


    if ($(window).width() < 500){
        $('.pos-sticky-bottom').hide();
        $(window).scroll(function(){
            $('.pos-sticky-bottom').slideDown(125);
        });
    }


   if( $('.pos-sticky-bottom').length ) {

        function getScroll() {
            var b = document.body;
            var e = document.documentElement;
            return {
                left: parseFloat( window.pageXOffset || b.scrollLeft || e.scrollLeft ),
                top: parseFloat( window.pageYOffset || b.scrollTop || e.scrollTop )
            };
        }

        var myFooter = $('footer');
        myFooter.data( 'position', myFooter.position() );




        $(window).scroll(function() {
                var hPos = myFooter.data('position'), scroll = getScroll();
                //var f_height = myFooter.height();
                var f_above = scroll.top - (hPos.top - $(window).height());

                if ( (hPos.top - $(window).height()) < scroll.top){
                        //hide
                        $('.pos-sticky-bottom').css({
                            "position": "fixed",
                            "bottom" : f_above
                        });
                        //$('main').addClass('margin-fix-home');
                        //console.log('remove fixed');
                }
                else {
                    //show
                    $('.pos-sticky-bottom').css({
                            "position": "fixed",
                            "bottom" : "0"
                        });
                    //console.log('hPos.top is ' + hPos.top);
                    //console.log('scroll.top is ' + scroll.top);
                }
                //console.log('hPos.top is ' + hPos.top);
                //console.log('scroll.top is ' + scroll.top);


        });





        $(window).resize(function() {

                var myFooter = $('footer');
                myFooter.data( 'position', myFooter.position() );
                var hPos = myFooter.data('position'), scroll = getScroll();
                //var f_height = myFooter.height();
                var f_above = scroll.top - (hPos.top - $(window).height());

                if ( (hPos.top - $(window).height()) < scroll.top){
                        //hide
                        $('.pos-sticky-bottom').css({
                            "position": "fixed",
                            "bottom" : f_above
                        });
                        //$('main').addClass('margin-fix-home');
                        //console.log('remove fixed');
                }
                else {
                    //show
                    $('.pos-sticky-bottom').css({
                            "position": "fixed",
                            "bottom" : "0"
                        });
                    //console.log('hPos.top is ' + hPos.top);
                    //console.log('scroll.top is ' + scroll.top);
                }
                //console.log('hPos.top is ' + hPos.top);
                //console.log('scroll.top is ' + scroll.top);


        });

    }

    $('.submit-bypass input, .submit-bypass select').on('change', function(){
        function getScroll() {
            var b = document.body;
            var e = document.documentElement;
            return {
                left: parseFloat( window.pageXOffset || b.scrollLeft || e.scrollLeft ),
                top: parseFloat( window.pageYOffset || b.scrollTop || e.scrollTop )
            };
        }

        var myFooter = $('footer');
        myFooter.data( 'position', myFooter.position() );
        var hPos = myFooter.data('position'), scroll = getScroll();
        //var f_height = myFooter.height();
        var f_above = scroll.top - (hPos.top - $(window).height());

        if ( (hPos.top - $(window).height()) < scroll.top){
                //hide
                $('.pos-sticky-bottom').css({
                    "position": "fixed",
                    "bottom" : f_above
                });
                //$('main').addClass('margin-fix-home');
                //console.log('remove fixed');
        }
        else {
            //show
            $('.pos-sticky-bottom').css({
                    "position": "fixed",
                    "bottom" : "0"
                });
            //console.log('hPos.top is ' + hPos.top);
            //console.log('scroll.top is ' + scroll.top);
        }
        //console.log('hPos.top is ' + hPos.top);
        //console.log('scroll.top is ' + scroll.top);

        //$('html, body').animate({scrollTop: '+=1px'});

    });

    $('.accordion .accordion-head').on('click', function(){
        $(this).next().toggle();
        var icon = $(this).find('i');
        if (icon.hasClass('fa fa-plus')){
            icon.removeClass('fa fa-plus').addClass('fa fa-minus');
        }
        else{
            icon.removeClass('fa fa-minus').addClass('fa fa-plus');
        }


        function getScroll() {
            var b = document.body;
            var e = document.documentElement;
            return {
                left: parseFloat( window.pageXOffset || b.scrollLeft || e.scrollLeft ),
                top: parseFloat( window.pageYOffset || b.scrollTop || e.scrollTop )
            };
        }

        var myFooter = $('footer');
        myFooter.data( 'position', myFooter.position() );

        var myFooter = $('footer');
        myFooter.data( 'position', myFooter.position() );
        var hPos = myFooter.data('position'), scroll = getScroll();
        //var f_height = myFooter.height();
        var f_above = scroll.top - (hPos.top - $(window).height());

        if ( (hPos.top - $(window).height()) < scroll.top){
                //hide
                $('.pos-sticky-bottom').css({
                    "position": "fixed",
                    "bottom" : f_above
                });
                //$('main').addClass('margin-fix-home');
                //console.log('remove fixed');
        }
        else {
            //show
            $('.pos-sticky-bottom').css({
                    "position": "fixed",
                    "bottom" : "0"
                });
            //console.log('hPos.top is ' + hPos.top);
            //console.log('scroll.top is ' + scroll.top);
        }
        //console.log('hPos.top is ' + hPos.top);
        //console.log('scroll.top is ' + scroll.top);

        //$('html, body').animate({scrollTop: '+=1px'});



    });

    //********MODAL STYLE********//

    $('.help-text-icon').on('click', function(e) {
        e.stopPropagation();
        var $clicked = $(this);
        var helpText = $clicked.find('.help-text-container').html();
        //console.log(helpText);
        $('.help-text-modal .inner').html(helpText);
        $('.help-text-modal').removeClass('hidden');
    });


    $('.help-text-modal .close').on('click', function(){
        $('.help-text-modal').addClass('hidden');
    });


    $('.help-text-modal').on('click', function(e){
        e.stopPropagation();
        $('.help-text-modal').addClass('hidden');
    });

    //********MODAL STYLE END********//


});